var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconsTrashWhite = function SvgIconsTrashWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.818 6.25A.805.805 0 0 1 2 5.458c0-.403.312-.736.716-.785l.102-.006H6.91V3.083c0-.874.733-1.583 1.636-1.583h4.91c.903 0 1.636.709 1.636 1.583v1.584h4.09c.453 0 .819.354.819.791a.801.801 0 0 1-.716.786l-.102.006h-.818v12.667c0 .828-.658 1.508-1.496 1.577l-.14.006H5.272c-.856 0-1.559-.636-1.63-1.447l-.007-.136V6.25h-.818zm13.91 0H5.272v12.667h11.454V6.25zm-5.933 3.167a.81.81 0 0 1 .812.692l.007.1v4.75a.805.805 0 0 1-.819.791.81.81 0 0 1-.811-.692l-.007-.1v-4.75c0-.437.367-.791.818-.791zm-3.272 1.187a.81.81 0 0 1 .812.693l.006.099v2.375a.805.805 0 0 1-.818.791.81.81 0 0 1-.812-.692l-.006-.1v-2.374c0-.437.366-.792.818-.792zm6.545 0a.81.81 0 0 1 .812.693l.006.099v2.375a.805.805 0 0 1-.818.791.81.81 0 0 1-.812-.692l-.006-.1v-2.374c0-.437.366-.792.818-.792zm-.613-7.52h-4.91v1.583h4.91V3.083z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};

export default SvgIconsTrashWhite;